var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",attrs:{"id":"wrapper"}},[_c('HeaderFront'),_c('router-view'),_c('FooterFront')],1)}
var staticRenderFns = []

export { render, staticRenderFns }